import { TableCell, withStyles, createStyles } from '@material-ui/core';

export const SHeadTableCell = withStyles(() =>
  createStyles({
    head: {
      fontWeight: 700,
      borderBottom: 'none',
      color: '#304497',
      fontSize: '16px',
    },
  })
)(TableCell);

